<template>
  <div>
    <div class="playerbg">
      <div class="header">
        <div class="title">
            <div class="han">赛事列表</div>
            <div class="eng">Competitions</div>
        </div>
        <div class="search">
            <input class="search-input" type="text" placeholder="请输入赛事名称搜索" v-model="searchVal">
            <span class="search-btn"  @click="search()">搜索</span>
            <img class="search-icon" src="../../../assets/search_icon.png" alt="" >
        </div>
        <div class="status">
            <div class="status-cell" v-for="(status,index) in statusList" :key="index" :class="activeStatus == index? 'activeBg':'inactiveBg' " @click="statusSwitch(index,status.code)">{{status.name}}</div>
        </div>
     </div>
    </div>
    <!--近期赛事-->
    <div style="background-color: #f4f4f4;min-height:600px;">
        <div class="content" >
            <MatchList v-if="websitePageMatchList.length>0" :websitePageMatchList="websitePageMatchList" v-for="(item, index) in websitePageMatchList" :key="index" :item="item"/>
        <div class="empty" v-else>
          暂无赛事
        </div>
        </div>
        <div class="pages" style="text-align: center;padding: 30px 0;" v-if="websitePageMatchList.length !==0">
            <a-pagination v-model="current" :total="totalNum" :defaultPageSize="params.pageSize" show-less-items @change="onChange"/>
        </div>
    </div>
    
  </div>
</template>

<script>
import store from '@/store'
// import matchFun from '@comm/utils/matchFun'
import MatchList from '@comm/components/MatchList'
export default {
  name: 'RecentMatch',
  data () {
    return {
    //   matchFun: matchFun,
      websitePageMatchList: [], // 赛事列表，
      totalNum: 0,
      params: {
        programId: this.$route.query.programId,
        pageNum: 1,
        pageSize: 20,
        keyWord: -1,
        status: -1
      },
      statusList: [
        {code: -1, name: '全部'},
        {code: 1, name: '计划中', bgColor: '#b99523'},
        {code: 2, name: '报名中', bgColor: '#F73C13'},
        {code: 3, name: '进行中', bgColor: '#008000'},
        {code: 4, name: '已结束', bgColor: '#BBB'}
      ],
      current: 1,
      searchVal: null,
      activeStatus: 0
    }
  },
  components: {
    MatchList,
  },
  created: function () {
    this.findData()
  },
  methods: {
    findData () {
      this.$api.match.programPageMatchList(this.params).then(res => {
        if (res.status === 0) {
          this.websitePageMatchList = res.data
          this.totalNum = res.total
        }
      }).catch(err => {
        console.log(err)
      })
    },
    onChange (page) {
      this.params.pageNum = page
      this.findData()
    },
    search () {
      this.params.pageNum = 1
      this.params.keyWord = -1
      if (this.searchVal !== '' && this.searchVal !== undefined && this.searchVal !== null) {
        this.params.keyWord = this.searchVal
      }
      this.findData()
    },
    statusSwitch (index, code) {
      this.params.pageNum = 1
      this.activeStatus = index
      this.params.status = code
      this.findData()
    },
    matchClick (id, programId) {
      store.commit('match/MATCH_CHANGE_ACTIVE_MENU', 1)
      this.$router.push({name: 'MatchDetail', query: {matchId: id, programId: programId}})
    }
  }
}
</script>

<style lang="scss" scoped>
.inactiveBg{
  color: #000;
}
.activeBg{
  color: #b01f23;
  font-weight: bold;
}
.playerbg{
  height: 200px;
  padding-top: 40px;
  background-image: url('../../../assets/weapon/playertopbg.jpg');
}
.header{
  width: 1200px;
  padding: 30px 0 20px 0;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: rgb(236, 236, 236);
  border-radius: 10px;
  padding: 40px;
}
.search{
  // background-color: green;
  position: relative;
}
.search-input{
  width: 330px;
  padding-left: 50px;
  margin-left: 30px;
  border: 0px;
  height: 50px;
  outline: none;
  border-bottom: 1px solid #b3b3b3;
  font-size: 13px;
}
.search-icon{
  width: 17px;
  position:absolute;
  left: 40px;
  top: 15px;
}
.han{
  font-size: 20px;
  margin-right: 10px;
  font-weight: bold ;
}
.eng{
  font-size: 20px;
}
.title{
  height: 31px;
  color: #333;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  // margin-bottom: 47px;
}
.status{
  flex: 2;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  color: #000;
  // background-color: red;
}
.status-cell{
  // width: 18%;
  flex: 1;
  margin-right: 8px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  padding: 5px 0;
  cursor: pointer;
}
.head-font{
  width: 1200px;margin: 0 auto;margin-top:40px;margin-bottom:15px;font-size:18px;color:#000;
}
.match-list{
  overflow: hidden;
}


.search-btn{
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 30px;
    padding-right: 30px;
    text-align: center;
    background: #b01f23;
    color:white;
    cursor: pointer;
}
//列表页
.content{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: row;
  }
  .empty{
    width: 100%;
    margin-top: 100px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/AllMatch.vue